import { render } from "./DevelopmentPage.vue?vue&type=template&id=c2030e76"
import script from "./DevelopmentPage.vue?vue&type=script&lang=js"
export * from "./DevelopmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__